import HashManager from "./hash-manager";
export default HashManager;
